// extracted by mini-css-extract-plugin
export default {"agencies":"agencies-page_agencies__8Pa13"};